export const useFormConfig = () => {
  return {
    courseCategoryForm: {
      formTitle: "Course Category",
      initialFormData: {
        title: "",
        remarks: "",
      },
      fieldConfig: [ 
        {
          key: "title",
          label: "Course Category Title",
          type: "text",
          placeholder: "Enter Course Category Title",
          required: true,
          alphaOnly: true 
        },
        {
          key: "remarks",
          label: "Course Category Description",
          type: "text",
          placeholder: "Enter Course Category Description",
          required: true,
          alphaOnly: true 
        }
      ],
    },
  };
};
